export default function ThankYou() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Thank You!</h1>
        <p style={styles.text}>
          Your registration has been successfully submitted.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#2d3946",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px"
  },
  card: {
    backgroundColor: "white",
    padding: "40px",
    borderRadius: "12px",
    maxWidth: "500px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)"
  },
  title: {
    color: "#e4af2f",
    fontSize: "2.2rem",
    marginBottom: "15px",
    fontWeight: "bold"
  },
  text: {
    color: "#2d3946",
    fontSize: "1.2rem",
    lineHeight: "1.6"
  }
};
